export const LIVE_RADIO_LIST = 'LIVE_RADIO_LIST';  // 直播列表